import { useRouter } from "next/navigation";
import { useEffect, useMemo, useRef } from "react";
import { removeFalsyValues } from "@/lib/utils";
import { SearchParamsType } from "@/redux/slices/searchParams.slice";

const useUpdateSearchParams = (params: SearchParamsType) => {
  const router = useRouter();
  const isInteracting = useRef(false);

  // Filter out falsy values before processing
  const filteredParams = useMemo(
    () => ({ ...removeFalsyValues(params), page: 1 }),
    [params]
  );

  useEffect(() => {
    isInteracting.current = true;

    const timeout = setTimeout(() => {
      isInteracting.current = false;
      const updatedParams = new URLSearchParams();

      Object.entries(filteredParams).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v) => updatedParams.append(key, v));
        } else {
          updatedParams.set(key, String(value));
        }
      });

      router.push(`/all-units?${updatedParams.toString()}`, { scroll: false });
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [filteredParams]);

  return { isInteracting }; // Return interaction state if needed
};

export default useUpdateSearchParams;
